/**
 * NOVAPAY-116 / COMMERCE-LAUNCH-164A-R1 — NovaPay checkout visibility gate (UI).
 * COMMERCE-LAUNCH-168D4 — production mode + public visible = selectable for all customers.
 *
 * Staging: selectable when NOVAPAY_CHECKOUT_STAGING_ENABLED mirror is true.
 * Production sandbox (legacy): allowlist-only unless public visible.
 * Production live: VITE_NOVAPAY_MODE=production + VITE_NOVAPAY_PUBLIC_VISIBLE=true.
 */
import { telegramUserId } from "./customer-profile-v2.js";

/** Staging bake default; production build overrides via VITE_* below. */
export const NOVAPAY_CHECKOUT_STAGING_ENABLED = true;

/** Owner + canary allowlist — sandbox NovaPay visible only for these Telegram IDs in production. */
const NOVAPAY_SANDBOX_ALLOWLIST = new Set(["475734587"]);

function appEnv(): string {
  return String(import.meta.env.VITE_APP_ENV ?? "").trim().toLowerCase();
}

function novapayMode(): string {
  return String(import.meta.env.VITE_NOVAPAY_MODE ?? "sandbox").trim().toLowerCase();
}

function publicVisible(): boolean {
  return String(import.meta.env.VITE_NOVAPAY_PUBLIC_VISIBLE ?? "").trim().toLowerCase() === "true";
}

/** True when production bake exposes live (non-sandbox) NovaPay to ordinary customers. */
export function isNovapayProductionUiEnabled(): boolean {
  return appEnv() === "production" && novapayMode() === "production" && publicVisible();
}

/** True when NovaPay card method may appear for the current Telegram user. */
export function isNovapayMethodSelectable(): boolean {
  if (appEnv() === "production") {
    // COMMERCE-LAUNCH-168D4 — general Customer production.
    if (novapayMode() === "production") {
      return publicVisible();
    }
    // Legacy sandbox-in-production review path (allowlist unless public).
    if (novapayMode() === "sandbox") {
      if (publicVisible()) return true;
      const uid = telegramUserId();
      return Boolean(uid && NOVAPAY_SANDBOX_ALLOWLIST.has(uid));
    }
    return false;
  }
  return NOVAPAY_CHECKOUT_STAGING_ENABLED === true;
}

/** Legacy name — true means hide/disable NovaPay (degraded / not selectable). */
export function isNovapayCheckoutDegradedStaging(): boolean {
  return !isNovapayMethodSelectable();
}
